<template>
  <b-container class="vehicle-management" fluid>
    <page-title icon="fas fa-cogs">
      <translate>Company Fleet</translate>
      <template #extras>
        <b-button variant="secondary" size="sm" v-b-modal.modalAddVehicle>
          <font-awesome-icon icon="plus-circle" />
          <translate>New Vehicle</translate>
        </b-button>
      </template>
    </page-title>

    <api-list ref="vehiclesList" type="vehicles" :model="models.vehicles" :quick-filters="quickFiltersSetup.vehicles" />

    <b-modal id="modalAddVehicle" ref="modalAddVehicle" :hide-footer="true">
      <template #modal-title><translate>Add New Company Vehicle</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <api-item-edit type="vehicles" :model="models.vehicles" @success="$refs.vehiclesList.refreshTable(); $refs.modalAddVehicle.hide();" />
    </b-modal>

  </b-container>
</template>

<script>
import ApiList from '@/components/ApiLists/ApiList'
import ApiItemEdit from '@/components/ApiLists/ApiItemEdit'

export default {
  name: 'VehiclesList',
  title() {
    return this.$gettext('Company Fleet')
  },
  components: {
    ApiList,
    ApiItemEdit
  }
}
</script>
